import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [{
            path: '/',
            redirect: 'index'
        },
        {
            path: '/welcome',
            name: '欢迎页',
            component: () =>
                import ('@/page/welcome/welcome')
        },
        {
            path: '/help',
            name: '操作手册',
            component: () =>
                import ('@/page/help/help')
        },
        {
            path: '/setNewPsw',
            name: '设置新密码页',
            component: () =>
                import ('@/page/setNewPsw/setNewPsw')
        },
        {
            path: '/phoneSure',
            name: '手机验证页',
            component: () =>
                import ('@/page/phoneSure/phoneSure')
        },
        {
            path: '/completeInfo',
            name: '完善信息页',
            component: () =>
                import ('@/page/completeInfo/completeInfo')
        },
        {
            path: '/home',
            component: () =>
                import ('@/components/Home'),
            children: [{
                    path: '/index',
                    name: '主页',
                    component: () =>
                        import ('@/page/index/index')
                },
                {
                    path: '/message',
                    name: '消息页',
                    component: () =>
                        import ('@/page/message/message')
                },
                {
                    path: '/mineIndex',
                    name: '我的',
                    component: () =>
                        import ('@/page/mineIndex/mineIndex'),
                },

            ]
        },
        {
            path: '/messageDetail',
            name: '消息详情',
            component: () =>
                import ('@/page/message/message-detail')
        },

        {
            path: '/indexPage',
            name: '跳转页',
            component: () =>
                import ('@/page/index/indexPage'),
        },
        {
            path: '/errPage',
            name: '跳转页',
            component: () =>
                import ('@/page/errPage/errPage'),
        },
        {
            path: '/errServer',
            name: '服务器异常',
            component: () =>
                import ('@/page/errPage/errServer'),
        },
        {
            path: '/myMaterial',
            name: '教职工认证',
            component: () =>
                import ('@/page/myMaterial/myMaterial'),
        },
        {
            path: '/parentMsg',
            name: '我的资料',
            component: () =>
                import ('@/page/parentMsg/parentMsg'),
        },
        {
            path: '/myChild',
            name: '我的孩子',
            component: () =>
                import ('@/page/myChild/myChild'),
        },
        {
            path: '/addChild',
            name: '新增孩子',
            component: () =>
                import ('@/page/myChild/addChild')
        },
        {
            path: '/deleteChild',
            name: '删除孩子',
            component: () =>
                import ('@/page/myChild/delChild')
        },
        {
            path: '/login',
            name: '登录页',
            component: () =>
                import ('@/page/login/login')
        },
        {
            path: '/recognition',
            name: '人脸识别',
            component: () =>
                import ('@/page/recognition/index/index')
        },
        {
            path: '/history',
            name: '人脸识别历史照片',
            component: () =>
                import ('@/page/recognition/history/history')
        },
        {
            path: '/picAudit',
            name: '人脸识别照片审核',
            component: () =>
                import ('@/page/recognition/picAudit/picAudit')
        },
        {
            path: '/upLoadPic',
            name: '人脸识别照片上传',
            component: () =>
                import ('@/page/recognition/upLoadPic/upLoadPic')
        },
        {
            path: '/registeredStatus',
            name: '人脸识别照片审核状态',
            component: () =>
                import ('@/page/recognition/registeredStatus/registeredStatus')
        },
        {
            path: '/failureSubmit',
            name: '人脸识别故障提交',
            component: () =>
                import ('@/page/recognition/failureSubmit/failureSubmit')
        },
        {
            path: '/viewfeedback',
            name: '人脸识别查看故障反馈页',
            component: () =>
                import ('@/page/recognition/viewfeedback/viewfeedback')
        },
        {
            path: '/faulthandling',
            name: '人脸识别故障处理页',
            component: () =>
                import ('@/page/recognition/faulthandling/faulthandling')
        },
        {
            path: '/submitSuccess',
            name: '人脸识别提交成功页',
            component: () =>
                import ('@/page/recognition/submitSuccess/submitSuccess')
        },
        {
            path: '/feedbackInfo',
            component: () =>
                import ('@/page/recognition/feedbackInfo/feedbackInfo')
        },
        // 人脸识别的帮助页面
        {
            path: '/faceRecognitionItem',
            component: () =>
                import ('@/page/help/faceRecognitionItem')
        },
        // 预约点餐的帮助页面
        {
            path: '/orderItem',
            component: () =>
                import ('@/page/help/orderItem')
        },
        // 餐饮管控的帮助页面
        {
            path: '/orderControlItem',
            component: () =>
                import ('@/page/help/orderControlItem')
        },
        // 教职工认证帮助页面
        {
            path: '/facultyCertification',
            component: () =>
                import ('@/page/help/facultyCertificationItem')
        },
        //一卡通帮助页面
        {
            path: '/oneCardItem',
            component: () =>
                import ('@/page/help/oneCardItem')
        },
        //在线报修页面
        {
            path: '/repairItem',
            component: () =>
                import ('@/page/help/repairItem')
        },
        //报修管理页面
        {
            path: '/repairManageItem',
            component: () =>
                import ('@/page/help/repairManageItem')
        },
        //维修工单页面
        {
            path: '/repairOrderItem',
            component: () =>
                import ('@/page/help/repairOrderItem')
        },
        // 意见反馈页面
        {
            path: '/feedback',
            component: () =>
                import ('@/page/feedback/feedback_index')
        },
        // 我的反馈
        {
            path: '/myFeedback',
            component: () =>
                import ('@/page/feedback/my_feedback')
        },
        // 反馈详情页面
        {
            path: '/feedbackDetail',
            component: () =>
                import ('@/page/feedback/feedback_detail')
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js